












import { Component, Prop, Vue } from 'vue-property-decorator';
import { Rules, FORMAT } from '@/core/Rules';
import {system_info} from "@/core/utils";

@Component
export default class SendVerifyCode extends Vue {
    //手机号码
    @Prop({
        type: String,
        required: true
    })
    public mobile!: string;

    //事件名称
    @Prop({
        type: String,
        required: true
    })
    public event!: string;

    //请求地址
    @Prop({
        type: String
    })
    public url!: string;

    //间隔时间
    @Prop({
        type: Number,
        default: 60
    })
    public delay!: number;

    //秒
    private second: number = 0;

    //倒计时
    private countDown(delay: number) {
        this.second = delay
        if (delay > 0) {
            setTimeout(() => {
                this.countDown(delay - 1);
            }, 1000);
        }
    }
    //发送
    private onSend() {
    const rules = new Rules();
    rules.join('mobile', FORMAT.NOT_NULL, "请输入手机号码");
    rules.join('mobile', FORMAT.MOBILE, "请输入正确的手机号码");
    const plat_id = system_info.get('id')
    if (rules.test({mobile: this.mobile}, (rule) => {
      this.$emit('fail', rule.message);
    })) {
      console.log(plat_id , this.event , this.mobile)
      this.axios.post(this.$URL.SEND_VERIFY_CODE, {
        mobile: this.mobile,
        event: this.event,
        plat_id: plat_id,
      }).then((res: any) => {
        if (res.code == 1) {
          this.countDown( this.delay );
          this.$emit('success');
        } else {
          this.$emit('fail', res.message || res.msg);
        }
      });
    }
  }
}
